import { createMemo, createSignal, onMount, batch } from 'solid-js'
import { Portal } from 'solid-js/web'
import { res2json, hourPadStart } from '@/utils'
import * as constants from '@lib/constants'
import { addToast } from '@/components/Toast'
import account from '@/store/account'

export default function RobotTiming() {
  const [loading, setLoading] = createSignal(true)

  return (
    <>
      <div class="flex flex-col gap-4">
        <div class="breadcrumbs text-sm">
          <ul>
            <li><a href="/home">后台首页</a></li>
            <li>机器人时间规则</li>
          </ul>
        </div>
        <div class="flex items-center justify-between">
          <h2 class="text-xl">机器人时间规则</h2>
          <button onClick={() => { window.fanSettingsShortcut.showModal() }} class="btn btn-success text-white">快速设定</button>
        </div>
        <FanRobotTiming setLoading={setLoading} />
      </div>

      <Portal mount={document.body}>
        {loading() && (<div class="fixed left-2 right-2 bottom-0"><progress class="progress progress-success w-full"></progress></div>)}

        <FanSettingsShortcutDialog />
      </Portal>
    </>
  )
}

const defaultFanSettings = Object.fromEntries(Array(24).fill(0).map((_, i) => ([hourPadStart(i), {
  fan: { min: constants.defaultMinNumberOfRobots, max: constants.defaultMaxNumberOfRobots },
  zheng: { min: constants.defaultMinNumberOfRobots, max: constants.defaultMaxNumberOfRobots },
  nian: { min: constants.defaultMinNumberOfRobots, max: constants.defaultMaxNumberOfRobots },
  jiao: { min: constants.defaultMinNumberOfRobots, max: constants.defaultMaxNumberOfRobots },
  dan: { min: constants.defaultMinNumberOfRobots, max: constants.defaultMaxNumberOfRobots },
  shuang: { min: constants.defaultMinNumberOfRobots, max: constants.defaultMaxNumberOfRobots },
  da: { min: constants.defaultMinNumberOfRobots, max: constants.defaultMaxNumberOfRobots },
  xiao: { min: constants.defaultMinNumberOfRobots, max: constants.defaultMaxNumberOfRobots },
  tong: { min: constants.defaultMinNumberOfRobots, max: constants.defaultMaxNumberOfRobots },
  zhong: { min: constants.defaultMinNumberOfRobots, max: constants.defaultMaxNumberOfRobots },
  jia: { min: constants.defaultMinNumberOfRobots, max: constants.defaultMaxNumberOfRobots },
  te: { min: constants.defaultMinNumberOfRobots, max: constants.defaultMaxNumberOfRobots },
  te_dan: { min: constants.defaultMinNumberOfRobots, max: constants.defaultMaxNumberOfRobots },
  te_shuang: { min: constants.defaultMinNumberOfRobots, max: constants.defaultMaxNumberOfRobots },
  te_da: { min: constants.defaultMinNumberOfRobots, max: constants.defaultMaxNumberOfRobots },
  te_xiao: { min: constants.defaultMinNumberOfRobots, max: constants.defaultMaxNumberOfRobots },
}])))

function FanRobotTiming({ setLoading }) {
  const [settings, setSettings] = createSignal(defaultFanSettings)

  const [sending, setSending] = createSignal(false)
  const [errors, setErrors] = createSignal({})

  async function load() {
    setLoading(true)
    return fetch(`/api/${account().game_code}/settings/fan-robot-timing`).then(res2json).then(r => {
      setSettings(Object.keys(r.data).length ? r.data : defaultFanSettings)
    }).finally(() => { setLoading(false) })
  }
  onMount(() => {
    load()
  })

  async function submit(e) {
    e.preventDefault()
    if (sending()) {
      return false
    }
    setSending(true)
    return fetch(`/api/${account().game_code}/settings/fan-robot-timing`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(settings())
    }).then(res2json).then(() => {
      addToast({ message: '已保存' })
    }).finally(() => { setSending(false) })
  }

  async function reset() {
    if (sending()) {
      return false
    }
    setSending(true)
    return fetch(`/api/${account().game_code}/settings/fan-robot-timing`, {
      method: 'DELETE'
    }).then(res2json).then(() => load()).then(() => {
      addToast({ message: '已重置' })
    }).finally(() => { setSending(false) })
  }

  const getValue = (i, at) => {
    const t = hourPadStart(i)
    return (settings()[t] ?? defaultFanSettings[t])[at] ?? { min: constants.defaultMinNumberOfRobots, max: constants.defaultMaxNumberOfRobots }
  }
  const setValue = (i, at, pos, val) => setSettings(e => {
    e[hourPadStart(i)][at][pos] = val
    return { ...e }
  })

  return (
    <form onSubmit={submit} class="overflow-x-auto">
      <table class="table whitespace-nowrap">
        <thead>
          <tr class="bg-base-200">
            <th>时间段</th>
            <th>玩法</th>
            <th>配置数量</th>
          </tr>
        </thead>
        <tbody>
          {Array(24).fill(0).map((_, i) => (
            <>
              <tr>
                <td rowspan="16" class="font-mono">{`${hourPadStart(i)}:00`}<br />~<br />{`${hourPadStart(i)}:59`}</td>
                <td>番</td>
                <td>
                  <div class="flex items-center gap-2 lg:gap-4">
                    最小托: <input type="number" value={getValue(i, 'fan').min} onChange={e => setValue(i, 'fan', 'min', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                    最大托: <input type="number" value={getValue(i, 'fan').max} onChange={e => setValue(i, 'fan', 'max', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                  </div>
                </td>
              </tr>
              <tr>
                <td>正</td>
                <td>
                  <div class="flex items-center gap-2 lg:gap-4">
                    最小托: <input type="number" value={getValue(i, 'zheng').min} onChange={e => setValue(i, 'zheng', 'min', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                    最大托: <input type="number" value={getValue(i, 'zheng').max} onChange={e => setValue(i, 'zheng', 'max', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                  </div>
                </td>
              </tr>
              <tr>
                <td>念</td>
                <td>
                  <div class="flex items-center gap-2 lg:gap-4">
                    最小托: <input type="number" value={getValue(i, 'nian').min} onChange={e => setValue(i, 'nian', 'min', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                    最大托: <input type="number" value={getValue(i, 'nian').max} onChange={e => setValue(i, 'nian', 'max', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                  </div>
                </td>
              </tr>
              <tr>
                <td>角</td>
                <td>
                  <div class="flex items-center gap-2 lg:gap-4">
                    最小托: <input type="number" value={getValue(i, 'jiao').min} onChange={e => setValue(i, 'jiao', 'min', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                    最大托: <input type="number" value={getValue(i, 'jiao').max} onChange={e => setValue(i, 'jiao', 'max', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                  </div>
                </td>
              </tr>
              <tr>
                <td>单</td>
                <td>
                  <div class="flex items-center gap-2 lg:gap-4">
                    最小托: <input type="number" value={getValue(i, 'dan').min} onChange={e => setValue(i, 'dan', 'min', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                    最大托: <input type="number" value={getValue(i, 'dan').max} onChange={e => setValue(i, 'dan', 'max', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                  </div>
                </td>
              </tr>
              <tr>
                <td>双</td>
                <td>
                  <div class="flex items-center gap-2 lg:gap-4">
                    最小托: <input type="number" value={getValue(i, 'shuang').min} onChange={e => setValue(i, 'shuang', 'min', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                    最大托: <input type="number" value={getValue(i, 'shuang').max} onChange={e => setValue(i, 'shuang', 'max', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                  </div>
                </td>
              </tr>
              <tr>
                <td>大</td>
                <td>
                  <div class="flex items-center gap-2 lg:gap-4">
                    最小托: <input type="number" value={getValue(i, 'da').min} onChange={e => setValue(i, 'da', 'min', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                    最大托: <input type="number" value={getValue(i, 'da').max} onChange={e => setValue(i, 'da', 'max', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                  </div>
                </td>
              </tr>
              <tr>
                <td>小</td>
                <td>
                  <div class="flex items-center gap-2 lg:gap-4">
                    最小托: <input type="number" value={getValue(i, 'xiao').min} onChange={e => setValue(i, 'xiao', 'min', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                    最大托: <input type="number" value={getValue(i, 'xiao').max} onChange={e => setValue(i, 'xiao', 'max', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                  </div>
                </td>
              </tr>
              <tr>
                <td>通</td>
                <td>
                  <div class="flex items-center gap-2 lg:gap-4">
                    最小托: <input type="number" value={getValue(i, 'tong').min} onChange={e => setValue(i, 'tong', 'min', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                    最大托: <input type="number" value={getValue(i, 'tong').max} onChange={e => setValue(i, 'tong', 'max', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                  </div>
                </td>
              </tr>
              <tr>
                <td>中</td>
                <td>
                  <div class="flex items-center gap-2 lg:gap-4">
                    最小托: <input type="number" value={getValue(i, 'zhong').min} onChange={e => setValue(i, 'zhong', 'min', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                    最大托: <input type="number" value={getValue(i, 'zhong').max} onChange={e => setValue(i, 'zhong', 'max', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                  </div>
                </td>
              </tr>
              <tr>
                <td>加</td>
                <td>
                  <div class="flex items-center gap-2 lg:gap-4">
                    最小托: <input type="number" value={getValue(i, 'jia').min} onChange={e => setValue(i, 'jia', 'min', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                    最大托: <input type="number" value={getValue(i, 'jia').max} onChange={e => setValue(i, 'jia', 'max', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                  </div>
                </td>
              </tr>
              <tr>
                <td>特码</td>
                <td>
                  <div class="flex items-center gap-2 lg:gap-4">
                    最小托: <input type="number" value={getValue(i, 'te').min} onChange={e => setValue(i, 'te', 'min', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                    最大托: <input type="number" value={getValue(i, 'te').max} onChange={e => setValue(i, 'te', 'max', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                  </div>
                </td>
              </tr>
              <tr>
                <td>特码-单</td>
                <td>
                  <div class="flex items-center gap-2 lg:gap-4">
                    最小托: <input type="number" value={getValue(i, 'te_dan').min} onChange={e => setValue(i, 'te_dan', 'min', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                    最大托: <input type="number" value={getValue(i, 'te_dan').max} onChange={e => setValue(i, 'te_dan', 'max', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                  </div>
                </td>
              </tr>
              <tr>
                <td>特码-双</td>
                <td>
                  <div class="flex items-center gap-2 lg:gap-4">
                    最小托: <input type="number" value={getValue(i, 'te_shuang').min} onChange={e => setValue(i, 'te_shuang', 'min', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                    最大托: <input type="number" value={getValue(i, 'te_shuang').max} onChange={e => setValue(i, 'te_shuang', 'max', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                  </div>
                </td>
              </tr>
              <tr>
                <td>特码-大</td>
                <td>
                  <div class="flex items-center gap-2 lg:gap-4">
                    最小托: <input type="number" value={getValue(i, 'te_da').min} onChange={e => setValue(i, 'te_da', 'min', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                    最大托: <input type="number" value={getValue(i, 'te_da').max} onChange={e => setValue(i, 'te_da', 'max', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                  </div>
                </td>
              </tr>
              <tr>
                <td>特码-小</td>
                <td>
                  <div class="flex items-center gap-2 lg:gap-4">
                    最小托: <input type="number" value={getValue(i, 'te_xiao').min} onChange={e => setValue(i, 'te_xiao', 'min', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                    最大托: <input type="number" value={getValue(i, 'te_xiao').max} onChange={e => setValue(i, 'te_xiao', 'max', e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
                  </div>
                </td>
              </tr>
            </>
          ))}
        </tbody>
      </table>
      <div class="grid grid-cols-2 md:grid-cols-5 gap-4 pt-4">
        <div class="hidden md:block md:col-span-3"></div>
        <button type="button" onClick={() => reset()} class="btn w-full" disabled={sending()}>重置预设值</button>
        <button type="submit" class="btn btn-success text-white w-full" disabled={sending()}>保存</button>
      </div>
    </form>
  )
}

function FanSettingsShortcutDialog() {
  const [period, setPeriod] = createSignal([])
  const [methods, setMethods] = createSignal([])
  const [min, setMin] = createSignal(1)
  const [max, setMax] = createSignal(5)

  const [sending, setSending] = createSignal(false)
  const [errors, setErrors] = createSignal({})

  onMount(() => {
    new MutationObserver((e) => {
      if (e[0].target.open) {
        batch(() => {
          toggleAllDay(true)
          setMethods([])
          setMin(1)
          setMax(5)

          setErrors({})
        })
      }
    }).observe(window.fanSettingsShortcut, { attributes: true })
  })

  const allDaySelected = createMemo(() => {
    return period().length === 24
  })

  function toggleAllDay(val) {
    setPeriod(val ? Array(24).fill(0).map((_, i) => hourPadStart(i)) : [])
  }
  function togglePeriod(val) {
    setPeriod(e => {
      const i = e.indexOf(val)
      if (i > -1) {
        e.splice(i, 1)
        return [...e]
      }
      return [...new Set([...e, val])]
    })
  }
  function toggleMethods(val) {
    setMethods(e => {
      const i = e.indexOf(val)
      if (i > -1) {
        e.splice(i, 1)
        return [...e]
      }
      return [...new Set([...e, val])]
    })
  }

  async function submit(e) {
    e.preventDefault()
    if (sending()) {
      return
    }

    setSending(true)
    return fetch(`/api/${account().game_code}/settings/fan-robot-timing/shortcut`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        period: period(),
        methods: methods(),
        min: parseInt(min()),
        max: parseInt(max()),
      })
    }).then(res2json).then(r => {
      if (r.status >= 400) {
        setErrors(r.data)
      } else {
        document.location.reload()
      }
    }).finally(() => { setSending(false) })
  }

  function cancel() {
    window.fanSettingsShortcut.close()
  }

  return (
    <dialog id="fanSettingsShortcut" class="modal">
      <form onSubmit={submit} class="modal-box flex flex-col gap-4">
        <button type="button" onClick={() => cancel()} class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2" disabled={sending()}>✕</button>
        <h3 class="text-lg">托-快速设定</h3>
        <div class="form-control">
          <div class="label"><span class="label-text">时间段</span></div>
          <div class="grid grid-cols-2 gap-x-4">
            <label class="label cursor-pointer justify-start gap-2">
              <input type="checkbox" checked={allDaySelected()} onChange={e => toggleAllDay(e.target.checked)} class="checkbox" />
              <span class="label-text">全天</span>
            </label>
            {Array(12).fill(0).map((_, i) => (
              <>
                <label class="label cursor-pointer justify-start gap-2">
                  <input type="checkbox" checked={period().indexOf(hourPadStart(i + 12)) > -1} onChange={e => togglePeriod(hourPadStart(i + 12))} class="checkbox" />
                  <span class="label-text font-mono">{`${hourPadStart(i + 12)}:00~${hourPadStart(i + 12)}:59`}</span>
                </label>
                <label class="label cursor-pointer justify-start gap-2">
                  <input type="checkbox" checked={period().indexOf(hourPadStart(i)) > -1} onChange={e => togglePeriod(hourPadStart(i))} class="checkbox" />
                  <span class="label-text font-mono">{`${hourPadStart(i)}:00~${hourPadStart(i)}:59`}</span>
                </label>
              </>
            ))}
          </div>
          {errors().period && (<div class="label"><span class="label-text-alt text-error">{errors().period}</span></div>)}
        </div>
        <div class="form-control">
          <div class="label"><span class="label-text">玩法</span></div>
          <div class="grid grid-cols-3 gap-x-4">
            <label class="label cursor-pointer justify-start gap-2">
              <input type="checkbox" checked={methods().indexOf('fan') > -1} onChange={e => toggleMethods('fan')} class="checkbox" />
              <span class="label-text">番</span>
            </label>
            <label class="label cursor-pointer justify-start gap-2">
              <input type="checkbox" checked={methods().indexOf('zheng') > -1} onChange={e => toggleMethods('zheng')} class="checkbox" />
              <span class="label-text">正</span>
            </label>
            <label class="label cursor-pointer justify-start gap-2">
              <input type="checkbox" checked={methods().indexOf('nian') > -1} onChange={e => toggleMethods('nian')} class="checkbox" />
              <span class="label-text">念</span>
            </label>
            <label class="label cursor-pointer justify-start gap-2">
              <input type="checkbox" checked={methods().indexOf('jiao') > -1} onChange={e => toggleMethods('jiao')} class="checkbox" />
              <span class="label-text">角</span>
            </label>
            <label class="label cursor-pointer justify-start gap-2">
              <input type="checkbox" checked={methods().indexOf('dan') > -1} onChange={e => toggleMethods('dan')} class="checkbox" />
              <span class="label-text">单</span>
            </label>
            <label class="label cursor-pointer justify-start gap-2">
              <input type="checkbox" checked={methods().indexOf('shuang') > -1} onChange={e => toggleMethods('shuang')} class="checkbox" />
              <span class="label-text">双</span>
            </label>
            <label class="label cursor-pointer justify-start gap-2">
              <input type="checkbox" checked={methods().indexOf('da') > -1} onChange={e => toggleMethods('da')} class="checkbox" />
              <span class="label-text">大</span>
            </label>
            <label class="label cursor-pointer justify-start gap-2">
              <input type="checkbox" checked={methods().indexOf('xiao') > -1} onChange={e => toggleMethods('xiao')} class="checkbox" />
              <span class="label-text">小</span>
            </label>
            <label class="label cursor-pointer justify-start gap-2">
              <input type="checkbox" checked={methods().indexOf('tong') > -1} onChange={e => toggleMethods('tong')} class="checkbox" />
              <span class="label-text">通</span>
            </label>
            <label class="label cursor-pointer justify-start gap-2">
              <input type="checkbox" checked={methods().indexOf('zhong') > -1} onChange={e => toggleMethods('zhong')} class="checkbox" />
              <span class="label-text">中</span>
            </label>
            <label class="label cursor-pointer justify-start gap-2">
              <input type="checkbox" checked={methods().indexOf('jia') > -1} onChange={e => toggleMethods('jia')} class="checkbox" />
              <span class="label-text">加</span>
            </label>
            <label class="label cursor-pointer justify-start gap-2">
              <input type="checkbox" checked={methods().indexOf('te') > -1} onChange={e => toggleMethods('te')} class="checkbox" />
              <span class="label-text">特码</span>
            </label>
            <label class="label cursor-pointer justify-start gap-2">
              <input type="checkbox" checked={methods().indexOf('te_dan') > -1} onChange={e => toggleMethods('te_dan')} class="checkbox" />
              <span class="label-text">特码-单</span>
            </label>
            <label class="label cursor-pointer justify-start gap-2">
              <input type="checkbox" checked={methods().indexOf('te_shuang') > -1} onChange={e => toggleMethods('te_shuang')} class="checkbox" />
              <span class="label-text">特码-双</span>
            </label>
            <label class="label cursor-pointer justify-start gap-2">
              <input type="checkbox" checked={methods().indexOf('te_da') > -1} onChange={e => toggleMethods('te_da')} class="checkbox" />
              <span class="label-text">特码-大</span>
            </label>
            <label class="label cursor-pointer justify-start gap-2">
              <input type="checkbox" checked={methods().indexOf('te_xiao') > -1} onChange={e => toggleMethods('te_xiao')} class="checkbox" />
              <span class="label-text">特码-小</span>
            </label>
          </div>
          {errors().methods && (<div class="label"><span class="label-text-alt text-error">{errors().methods}</span></div>)}
        </div>
        <div class="form-control">
          <div class="label"><span class="label-text">托数量</span></div>
          <div class="grid grid-cols-2 gap-x-4">
            <label class="label cursor-pointer w-1/2 justify-start gap-2">
              <span class="label-text">最小</span>
              <input type="number" value={min()} onChange={e => setMin(e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
            </label>
            <label class="label cursor-pointer w-1/2 justify-start gap-2">
              <span class="label-text">最大</span>
              <input type="number" value={max()} onChange={e => setMax(e.target.value)} min={constants.minNumberOfRobots} max={constants.maxNumberOfRobots} class="input input-bordered input-sm w-16" />
            </label>
          </div>
          {errors().min && (<div class="label"><span class="label-text-alt text-error">{errors().min}</span></div>)}
          {errors().max && (<div class="label"><span class="label-text-alt text-error">{errors().max}</span></div>)}
        </div>
        {errors().default && (<div class="text-error">{errors().default}</div>)}
        <div class="modal-action flex gap-4">
          <button type="button" onClick={() => cancel()} class="btn px-8" disabled={sending()}>取消</button>
          <button type="submit" class="btn btn-success text-white px-8" disabled={sending()}>确定</button>
        </div>
      </form>
    </dialog>
  )
}
